import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notes-view',
  templateUrl: './notes-view.component.html',
  styleUrls: ['./notes-view.component.scss']
})
export class NotesViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
